"use client";
import {JSX, useState} from "react";

import {ButtonSimple} from "@/shared/ui/buttons";

import "./styles/header-dropdown.scss";

export interface HeaderDropdownItem {
    id: number | string;
    href: string;
    label: string;
}

export interface HeaderDropdownProps {
    label: string;
    href: string;
    items: Array<HeaderDropdownItem>;
}

export function HeaderDropdown({label, href, items}: HeaderDropdownProps): JSX.Element {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="header_dropdown" onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
            <ButtonSimple as="link" href={href} className="header_dropdown__trigger" variant="primary">
                {label}
            </ButtonSimple>
            {isOpen && items.length > 0 && (
                <>
                    {/* Invisible bridge to prevent gap between trigger and menu */}
                    <div className="header_dropdown__bridge" />
                    <div className="header_dropdown__menu">
                        {items.map((item) => (
                            <ButtonSimple as="link" key={item.id} href={item.href} className="header_dropdown__item" variant="primary">
                                {item.label}
                            </ButtonSimple>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
